import styled from "styled-components";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";

import DateSelect from "features/media/components/molecules/DateSelect";
import { Image } from "shared/components/atoms/Image";
import Grid from "features/media/components/atoms/Grid";
import Radio from "features/media/components/atoms/Radio";
import { TopicElement, Topic } from "shared/types";
import { useDescendantTopics } from "features/media/hooks/useDescendantTopics";

interface Props {
  data: TopicElement;
  topic: Topic;
}

export default function DevineBirthday({ data, topic }: Props) {
  const [day, setDay] = useState(0);
  const [gender, setGender] = useState("");
  const [, setCookie, removeCookie] = useCookies();

  const { topicDescendantTopics } = useDescendantTopics(topic, gender);

  const rows = data.text.split("\n");
  const onChangeDate = ({ day }: { day: number }) => setDay(day);
  const onChangeGender = (value: string) => setGender(value);

  useEffect(() => {
    if (day) {
      const index = day % topicDescendantTopics.length;
      const decendantTopic =
        index === 0
          ? topicDescendantTopics[index]
          : topicDescendantTopics[index - 1];
      const referrer = document.referrer
        ? `referrer=${encodeURIComponent(document.referrer)}`
        : null;
      const symbol = location.search ? "&" : "?";
      const redirectUrl = referrer
        ? decendantTopic.uri + symbol + referrer
        : decendantTopic.uri;
      setCookie("redirect_url", redirectUrl, { path: "/" });
    } else {
      removeCookie("redirect_url");
    }
  }, [day, gender, removeCookie, setCookie, topicDescendantTopics]);

  return (
    <BackGround src="/images/divination-form-bg.png">
      <Container>
        <Text>この鑑定では下記の内容を占います</Text>
        {rows.map((row: string, index: number) => (
          <Text key={index}>{`${index + 1}). ${row}`}</Text>
        ))}
      </Container>
      <Container>
        <Text>あなたの生年月日を教えてください</Text>
        <DateSelect onChange={onChangeDate} />
      </Container>
      <Container>
        <Text>あなたの性別を教えてください</Text>
        <Grid direction="row" alignItems="center" justify="space-between">
          <Radio value="male" checked={gender} onClick={onChangeGender}>
            男性
          </Radio>
          <Radio value="female" checked={gender} onClick={onChangeGender}>
            女性
          </Radio>
          <Radio value="other" checked={gender} onClick={onChangeGender}>
            その他
          </Radio>
        </Grid>
      </Container>
      <Container>
        <Link href="/users/auth/line" id="birthday_uranai_button">
          LINE登録でお試し鑑定
          <LinkDecoration
            src="https://cdn.miror.jp/item/free_label.png"
            width={120}
            height={132}
            layout="responsive"
          />
        </Link>
      </Container>
    </BackGround>
  );
}

const BackGround = styled.div`
  position: relative;
  background-image: url(${({ src }: { src: string }) => src});
  background-size: cover;
  background-position: center center;
  border-radius: 8px;
`;

const Container = styled.div`
  padding: 24px;
  border-bottom: 0.5px solid #f5f5f5;
`;

const Text = styled.div`
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1px;
  color: #fff;
  line-height: 32px;
  text-align: center;
`;

const Link = styled.a`
  width: 100%;
  height: 58px;
  border: none;
  border-radius: 25px !important;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 50%);
  background: rgb(245, 225, 240);
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 1px;
  font-family: ヒラギノ明朝 ProN;
  color: rgb(185, 80, 140);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const LinkDecoration = styled(Image)`
  width: 54px;
  position: absolute;
  top: -3px;
  left: -5px;
`;
